import { v1MatrixClubGet, IFormattedMatrixClubWorkout } from '@ifit/gateway-wolf-dashboard-service';
import { useQuery, UseQueryResult } from 'react-query';
import { FIVE_SECONDS, ONE_DAY } from '../../util/durations';
import { useSoftwareNumber } from '../selectors/use-software-number';
import { useEquipmentType } from '../selectors/use-equipment-type';
import { useLanguage } from '../selectors/use-language';
import { useDate } from '../selectors/use-date';
import { useUserType } from '../selectors/use-user-type';

export function useMatrixClub(disableCall: boolean): UseQueryResult<IFormattedMatrixClubWorkout[], Error> {
  const softwareNumber = useSoftwareNumber();
  const equipmentType = useEquipmentType();
  const language = useLanguage();
  const startingDate = useDate();
  const userType = useUserType();

  return useQuery<IFormattedMatrixClubWorkout[], Error>(
    ['matrix-club-workouts', { softwareNumber, equipmentType, language, startingDate, userType }],
    () =>
      v1MatrixClubGet({
        softwareNumber: Number.parseInt(softwareNumber, 10),
        limit: 15,
        headers: {
          language,
        },
        startingDate,
        equipmentType,
        userType,
        useBasicAuth: true,
        useGatewayCache: true,
      }),
    {
      staleTime: FIVE_SECONDS,
      cacheTime: ONE_DAY,
      enabled: Boolean(!disableCall),
    }
  );
}
